module.exports = __webpack_public_path__ + "img/play.01249846.png";